import BaseModelAPI from '../BaseModelAPI';

export default class ReportDelayDeliveryInstruction extends BaseModelAPI {
	static entity = 'newreport2191';
	static entityName = 'reportdelaydeliveryinstruction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterCustomerId = '';
			this.filterDestinationId = '';
			this.filterDiNumber = '';
			this.filterPoNoCustomer = '';
			this.filterPartId = '';
			this.tempId = 0;
			this.customerName = '';
			this.destinationName = '';
			this.diNumber = '';
			this.poNoCustomer = '';
			this.diDeliveryDate = '';
			this.partNumber = '';
			this.partName = '';
			this.qtyDelivery = 0;
			this.qtyActualSupply = 0;
			this.qtyOutstanding = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}